import {
    GROUP_JOBTITLE_DATA,   
    GROUP_JOBTITLE_GET_DATA,
    // Ticketing APIs
    GROUPBYTYPE_ADMIN_GET_DATA,
    GROUPBYTYPE_USER_GET_DATA,
    GROUPBY_ID_JOBTITLE_GET_DATA,
  } from "./Constants";
  
  const initialState = {
    loading: false,
    error: null,
    groupjobtitles: [],
    groupjobtitle: {},
    userGroup: [],
    adminGroup: [],
    group: {},

  };
  
  const Reducer = (state = initialState, action) => {
    console.log("action", action)
    switch (action.type) {
      case GROUP_JOBTITLE_DATA.GROUP_JOBTITLE_DATA_LOAD:
        console.log("GROUP_JOBTITLE_DATA_LOAD case inside");
        return {
          ...state,
          loading: true,
          error: null,
          groupjobtitles: [],
        };
      case GROUP_JOBTITLE_DATA.GROUP_JOBTITLE_DATA_SUCCESS:
        console.log("GROUP_JOBTITLE_DATA_SUCCESS case inside");
        return {
          ...state,
          loading: false,
          groupjobtitles: action.groupjobtitles,
          error: null,
        };
      case GROUP_JOBTITLE_DATA.GROUP_JOBTITLE_DATA_FAIL:
        console.log("GROUP_JOBTITLE_DATA_FAIL case inside");
        return {
          ...state,
          loading: false,
          error: action.error,
          groupjobtitles: [],
        };

      
      //Get
      case GROUP_JOBTITLE_GET_DATA.GROUP_JOBTITLE_GET_DATA_LOAD:
        return {
          ...state,
          loading: true,
          groupjobtitle: {},
          error: null,
        };
      case GROUP_JOBTITLE_GET_DATA.GROUP_JOBTITLE_GET_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          groupjobtitle: action.groupjobtitle,
          error: null,
        };
      case GROUP_JOBTITLE_GET_DATA.GROUP_JOBTITLE_GET_DATA_FAIL:
        return {
          ...state,
          loading: false,
          groupjobtitle: {},
          error: action.error,
        };
      //Ticketing APIs 
      //Get admin
      case GROUPBYTYPE_ADMIN_GET_DATA.GROUPBYTYPE_ADMIN_GET_DATA_LOAD:
            return {
              ...state,
              loading: true,
              error: null,
            };

          case GROUPBYTYPE_ADMIN_GET_DATA.GROUPBYTYPE_ADMIN_GET_DATA_SUCCESS:
            return {
              ...state,
              loading: false,
              adminGroup: action.adminGroup,
              error: null,
            };

          case GROUPBYTYPE_ADMIN_GET_DATA.GROUPBYTYPE_ADMIN_GET_DATA_FAIL:
            return {
              ...state,
              loading: false,
              error: action.error,
            };
      // get user      
      case GROUPBYTYPE_USER_GET_DATA.GROUPBYTYPE_USER_GET_DATA_LOAD:
            return {
              ...state,
              loading: true,
              error: null,
            };

          case GROUPBYTYPE_USER_GET_DATA.GROUPBYTYPE_USER_GET_DATA_SUCCESS:
            return {
              ...state,
              loading: false,
              userGroup: action.userGroup,
              error: null,
            };

          case GROUPBYTYPE_USER_GET_DATA.GROUPBYTYPE_USER_GET_DATA_FAIL:
            return {
              ...state,
              loading: false,
              error: action.error,
            };      
      //Get
      case GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_LOAD:
        return {
          ...state,
          loading: true,
          group: {},
          error: null,
        };
      case GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          group: action.group,
          error: null,
        };
      case GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_FAIL:
        return {
          ...state,
          loading: false,
          group: {},
          error: action.error,
        };      

          default:
            return state;

          
      
    }
  };
  
  export default Reducer;
  